module.exports = __webpack_public_path__ + "mc.71f4b02a0fa35791b0d7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mc.svg
// module chunks = styles